import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Plus, User, Bell, Search } from "lucide-react";

const tabs = [
  { id: "home", path: "/home", icon: Home, label: "Home" },
  { id: "search", path: "/search", icon: Search, label: "Cari" },
  { id: "create", path: "/create", icon: Plus, label: "Buat", primary: true },
  { id: "notif", path: "/notifications", icon: Bell, label: "Notif" },
  { id: "profile", path: "/profile", icon: User, label: "Profil" },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <nav
      className="fixed left-1/2 -translate-x-1/2 z-40"
      style={{
        // Float above the Emergent badge (which sits ~bottom:16px, height ~40px)
        bottom: "max(72px, calc(env(safe-area-inset-bottom) + 72px))",
      }}
      data-testid="bottom-nav"
    >
      <div className="flex items-center gap-1 bg-[#0f0f12]/90 backdrop-blur-xl border border-border rounded-full px-2 py-2 shadow-[0_10px_40px_rgba(0,0,0,0.6)]">
        {tabs.map((t) => {
          const Icon = t.icon;
          const active = location.pathname === t.path.split("?")[0];
          if (t.primary) {
            return (
              <button
                key={t.id}
                data-testid={`nav-${t.id}`}
                onClick={() => navigate(t.path)}
                className="h-12 w-12 rounded-full bg-primary text-primary-foreground glow-cyan flex items-center justify-center active:scale-95 transition-transform mx-1"
                aria-label={t.label}
              >
                <Icon className="h-5 w-5" strokeWidth={2.5} />
              </button>
            );
          }
          return (
            <Link
              to={t.path}
              key={t.id}
              data-testid={`nav-${t.id}`}
              className={`flex flex-col items-center justify-center gap-0.5 h-12 w-12 rounded-full transition-colors ${active ? "text-primary bg-primary/10" : "text-muted-foreground hover:text-foreground"}`}
              aria-label={t.label}
            >
              <Icon className="h-5 w-5" strokeWidth={active ? 2.5 : 2} />
              <span className="text-[9px] font-bold leading-none">{t.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
